import { render, staticRenderFns } from "./RiskToolbar.vue?vue&type=template&id=3031c848&scoped=true&"
import script from "./RiskToolbar.vue?vue&type=script&lang=js&"
export * from "./RiskToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RiskToolbar.vue?vue&type=style&index=0&id=3031c848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031c848",
  null
  
)

export default component.exports